import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  DistrictBrandingAPIResponse,
  DistrictBrandingPayload,
} from 'src/app/common/dtos/district.dto';
import { APICoreService } from '../../../../common/services/api-core/api-core.service';

@Injectable({
  providedIn: 'root',
})
export class DistrictBrandingService {
  private currentBrandingSubject =
    new BehaviorSubject<DistrictBrandingPayload | null>(null);

  currentBranding$ = this.currentBrandingSubject.asObservable();

  constructor(private apiService: APICoreService) {}

  setCurrentBranding(branding: DistrictBrandingPayload): void {
    this.currentBrandingSubject.next({ ...branding });
  }

  getDistrictBranding(
    districtId: number
  ): Observable<{ item: DistrictBrandingAPIResponse }> {
    return this.apiService.getRequest(
      `growelab/district-branding/${districtId}`
    );
  }

  createDistrictBranding(
    payload: DistrictBrandingPayload
  ): Observable<{ item: DistrictBrandingAPIResponse }> {
    return this.apiService.postRequest('growelab/district-branding', payload);
  }

  updateDistrictBranding(
    districtId: number,
    payload: DistrictBrandingPayload
  ): Observable<{ item: DistrictBrandingAPIResponse }> {
    return this.apiService.putRequest(
      `growelab/district-branding/${districtId}`,
      payload
    );
  }
}
